import script from "./BillingBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillingBanner.vue?vue&type=script&lang=ts&setup=true"

import "./BillingBanner.vue?vue&type=style&index=0&id=15dd9faf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15dd9faf"]])

export default __exports__